<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 动画效果 -->
    <transition name="fade" mode="out-in" appear>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
    <ApiSelect/>
  </div>
</template>

<script>
import ApiSelect from './components/ApiSelect.vue'
export default {
  name: 'App',
  components: {
    ApiSelect
  }
}
</script>

<style lang="less">
@import './common/alfont/iconfont.css';
@import './common/css/public.less';
@import './common/css/border.css';
@import './common/css/reset.css';
#app {
  // font-family: 'PingFang SC',Helvetica, Tahoma, Arial,'Hiragino Sans GB', 'Hiragino Sans GB W3', STXihei, STHeiti, SimHei, Heiti, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  min-height: 100vh;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select:none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  // height: 100%;
}
#app>div{
  padding-top: 72px;
}
// 动画样式
.fade-enter-active, .fade-leave-active{
  transition: all .3s;
}
.fade-enter{
  opacity: .5;
}
.fade-leave-to{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue